import React, { useEffect, useState } from 'react';
import '../css/layout-content.css'
import { Breadcrumb, Col, Layout, Menu, Modal, Row, theme } from 'antd';
import { Images } from '../assets';
import { matchRoutes, useLocation, useNavigate } from 'react-router-dom';
import { saveUserInfo } from '../redux/action';
import { useDispatch, useSelector } from 'react-redux';
import { LIST_MENU_SIDE_BAR } from '../constants/constants';
import { consoleLogUtil } from '../utils/consoleLogUtil';
import { getVisibleMenu } from '../utils/funcHelper';


const { Header, Content, Footer, Sider } = Layout;
const { confirm } = Modal;

const LayoutContent = ({ children }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const [currentPathLabel, setCurrentPathLabel] = useState();
    const [collapsed, setCollapsed] = useState(false);
    const userReducer = useSelector(state => state?.userReducer);
    const [listMenu, setListMenu] = useState([]);
    const {
        token: { colorBgContainer },
    } = theme.useToken();
    
    const useCurrentRoute = () => {
        if (location?.pathname == '/') return {}
        if (matchRoutes(LIST_MENU_SIDE_BAR, location)) {
            const [{ route }] = matchRoutes(LIST_MENU_SIDE_BAR, location);
            let routeCustom;
            if (route && route?.children) {
                routeCustom = {
                    ...route,
                    labelChil: route?.children?.find(obj => obj.path === location.pathname)?.label
                }
            } else {
                routeCustom = route;
            }
            return routeCustom
        } else {
            return {}
        }
    }
    const handleGetBreadcrumb = () => {
        if (location?.pathname == '/') {
            setCurrentPathLabel('');
        }
        LIST_MENU_SIDE_BAR.forEach(menu => {
            if (menu.path === location.pathname) {
                setCurrentPathLabel(menu.label);
            } else {
                if (menu.children) {
                    const chil = menu.children.find(obj => obj.path === location.pathname);
                    if (chil) {
                        setCurrentPathLabel(`${menu.label}/${chil.label}`);
                    }
                }
            }
        })
    }
    const handlePermissionMenu = () => {
        const menuForUser = getVisibleMenu(userReducer?.data?.roles?.map(item => parseInt(item.id)), LIST_MENU_SIDE_BAR);
        setListMenu([...menuForUser]);
    }

    const handleCLickMenu = (item) => {
        if (item.key == 'dang-xuat') {
            confirm({
                title: <>Bạn có chắc chắn muốn đăng xuất?</>,
                okText: "OK",
                okType: "danger",
                cancelText: "Hủy",
                async onOk() {
                    try {
                        dispatch(saveUserInfo(null));
                    } finally {
                    }
                },
            });
        } else {
            navigate(`/${item.key}`, { replace: true });
        }
        // saveLog(item?.key);
    }

    useEffect(() => {
        handleGetBreadcrumb();
    }, [location])
    useEffect(() => {
        if (userReducer?.data?.roles) {
            consoleLogUtil("vao day");
            handlePermissionMenu();
        }
    }, [userReducer?.data?.access_token, userReducer?.data?.roles, userReducer])
    return (
        <Layout
        style={{ minHeight: '100vh' }}
        >
            <Sider width={250} collapsible collapsed={collapsed} onCollapse={(value) => setCollapsed(value)} theme='light'>
                <div className="logo-vertical" >
                    <img src={Images.img_logo_app} className='img-logo' />
                </div>
                <Menu theme="light" defaultSelectedKeys={useCurrentRoute()?.key} mode="inline" items={listMenu} onClick={handleCLickMenu} style={{fontSize: 16}}/>
            </Sider>
            <Layout style={{ minHeight: '100vh' }}>
                <Header
                    className='color-header header-padding'
                >
                    <Row>
                        <Col span={18}>
                            <p className='title-header'>Hệ thống quản lý Tiktok Order</p>
                        </Col>
                        <Col span={6}>
                            <p className='user-name-header'><span className='txt-hello'>Xin chào</span>, {userReducer?.data?.user_info?.fullname}</p>
                        </Col>
                    </Row>
                    
                </Header>
                <Content
                    style={{
                        margin: '0 16px',
                    }}
                >
                    <Breadcrumb
                        style={{
                            margin: '16px 0',
                        }}
                    >
                        <Breadcrumb.Item>{currentPathLabel}</Breadcrumb.Item>
                    </Breadcrumb>
                    <div
                        style={{
                            paddingTop: 24,
                            paddingBottom: 24,
                            paddingLeft: 12,
                            paddingRight: 12,
                            background: "#FFF",
                            minHeight: `calc(100vh - 180px)`,
                            border: `1px solid #e7e7e7`,
                        }}
                        className='height-body'
                    >
                        {children}
                    </div>
                </Content>
                <Footer
                    style={{
                        textAlign: 'center',
                        background: 'transparent'
                    }}
                >
                    Bản quyền thuộc 9Fmedia ©2025
                </Footer>
            </Layout>
        </Layout>
    );
};
export default LayoutContent;